import { a } from './chunk-32KRFHOA.js';
export { a as useWhisper } from './chunk-32KRFHOA.js';
import './chunk-VO7VPLVP.js';

var o=a;

export { o as default };
